import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AbsNavComponent } from '../abs-nav/abs-nav.component';

import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';

import {AbsSkipContentDirective} from '../abs-utilities/abs-skip-content.directive';
import {AbsSetNextFocusDirective} from '../abs-utilities/abs-set-next-focus.directive';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    AbsNavComponent,
    AbsSkipContentDirective,
    AbsSetNextFocusDirective,
  ],
  exports: [
    AbsNavComponent,
    AbsSkipContentDirective,
    AbsSetNextFocusDirective,
  ],
  providers:[AbsDomHelperService],
})
export class AbsNavModule { }
